import { useState } from 'react'
import { makeStyles, TextField, Link as MuiLink } from '@material-ui/core'
import LocalShippingIcon from '@material-ui/icons/LocalShipping'
import ButtonSp from '../../components/ui/ButtonSp'
import Axios from 'axios'
import { orderStatusToTextMap } from '../../components/utility/trackingUtility'
import getConfig from 'next/config'
import Head from 'next/head'

const { publicRuntimeConfig } = getConfig()

const useStyles = makeStyles((theme) => ({
  root: {
    width: 320,
    height: 200,
    overflow: 'hidden',
    padding: theme.spacing(1),
    position: 'relative',
  },
  title: {
    ...theme.homeStyle.bodyText,
    color: theme.palette.primary.main,
    margin: `${theme.spacing(0)}px 0`,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  buttonsGroup: {
    display: 'flex',
    flexDirection: 'row',
  },
  button: {
    marginRight: theme.spacing(0.5),
    marginTop: theme.spacing(0.5),
    fontSize: '14px !important',
  },
  detail: {
    margin: 0,
    fontSize: 13,
    marginTop: theme.spacing(0.5),
  },
  copyRight: {
    fontSize: 10,
    color: 'grey',
    position: 'absolute',
    bottom: 0,
  },
}))

const TrackingEmbed = () => {
  const classes = useStyles()
  const [trackingCode, setTrackingCode] = useState('')
  const [searchedTrackingCode, setSearchedTrackingCode] = useState('')
  const [trackedStatus, setTrackedStatus] = useState('กำลังค้นหา...')

  const onSubmit = () => {
    setTrackedStatus('กำลังค้นหา...')
    setSearchedTrackingCode(trackingCode)
    Axios.post('/api/tracking/domestic', { tracking_code: trackingCode })
      .then((res) => {
        setTrackedStatus(res.data.order_status)
      })
      .catch((err) => setTrackedStatus('ไม่พบข้อมูล'))
  }

  const renderStatus = (status) => {
    if (orderStatusToTextMap[status]) return orderStatusToTextMap[status]
    else return status
  }

  return (
    <>
      <Head>
        <title>
          ระบบ เช็คพัสดุ เช็คเลขพัสดุ ติดตามพัสดุ เช็คสถานะพัสดุ ทุกขนส่ง
          SHIPPOP
        </title>
        <meta
          name="keywords"
          content="เช็คพัสดุ, ติดตามพัสดุ, เช็คเลขพัสดุ, ติดตามเลขพัสดุ, เช็คแทร็ค, ตามพัสดุ"
        />
        <meta
          name="description"
          content="ติดตามสถานะพัสดุ เช็คพัสดุ เช็คเลขพัสดุ Tracking ทุกขนส่งได้ง่ายๆกับ SHIPPOP เพียงแค่กรอกเลขพัสดุของท่าน บนหน้าเว็บคุณ"
        />
      </Head>
      <div className={classes.root}>
        <p className={classes.title}>
          <LocalShippingIcon fontSize="small" style={{ marginRight: 8 }} />
          ติดตามสถานะพัสดุ
        </p>
        <TextField
          variant="outlined"
          size="small"
          fullWidth
          placeholder="รหัสพัสดุ"
          value={trackingCode}
          onChange={(e) => {
            setTrackingCode(e.target.value)
          }}
        />
        {searchedTrackingCode && (
          <p className={classes.detail}>
            สถานะหมายเลข {searchedTrackingCode} คือ{' '}
            <strong>{renderStatus(trackedStatus)}</strong>
            <br />
            สามารถตรวจสอบสถานะแบบละเอียดได้{' '}
            <MuiLink
              href={`${publicRuntimeConfig.siteDomain}/tracking?typeid=domestic&tracking_code=${searchedTrackingCode}`}
              target="_blank"
            >
              คลิกที่นี่
            </MuiLink>
          </p>
        )}
        <div className={classes.buttonsGroup}>
          <ButtonSp size="small" className={classes.button} onClick={onSubmit}>
            ตรวจสอบสถานะ
          </ButtonSp>
          <ButtonSp
            size="small"
            color="default"
            className={classes.button}
            onClick={() => {
              setTrackingCode('')
              setSearchedTrackingCode('')
              setTrackedStatus(false)
            }}
          >
            ล้างข้อมูล
          </ButtonSp>
        </div>
        <p className={classes.copyRight}>
          © Copyright 2015 - {new Date().getFullYear()} All Rights Reserved by{' '}
          <MuiLink href="https://www.shippop.com/" target="_blank">
            SHIPPOP
          </MuiLink>
        </p>
      </div>
    </>
  )
}

export default TrackingEmbed
